import React, {useEffect, useRef} from 'react';
import {Dialog, useMediaQuery, useTheme} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';
import {t} from 'i18next';
import {useAnalytics} from '../../../../hooks/useAnalytics';
import {
  GA_EVENT_NAMES,
  GA_SUBPAGE_TYPE,
} from '../../../../constants/analyticsConstants';

interface SelectionDialogComponentProps {
  ContentComponent: React.ComponentType<any>; // Accept any React component
  openFrom?: string;
  hideNonConsilioProjects?: boolean;
}

const ProjectWorkSpaceSelectionDialog: React.FC<
  SelectionDialogComponentProps
> = ({ContentComponent, openFrom, hideNonConsilioProjects}) => {
  const closeCBFromChildRef = useRef<any | null>(null);
  const isOpen = useSelector((state: any) => state.dialog.isOpen);
  const {trackGAEvent} = useAnalytics();
  const prevIsOpenRef = useRef(false);

  const dialogReportName = useSelector(
    (state: RootState) => state.dialog.dialogReportName
  );

  useEffect(() => {
    if (isOpen && !prevIsOpenRef.current) {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.SUB_PAGE_VIEW,
        subPage: {
          subpage_name: t('gaTracking.reports.changeProjectandWorkspace'),
          subpage_type: GA_SUBPAGE_TYPE.MODAL,
        },
      });
    }

    prevIsOpenRef.current = isOpen;
  }, [isOpen, trackGAEvent]);

  const handleClose = () => {
    if (
      closeCBFromChildRef.current &&
      typeof closeCBFromChildRef.current === 'function'
    ) {
      closeCBFromChildRef.current();
    }
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        className: 'evidence-source-dialog',
        role: 'dialog',
        'aria-label': t('reports.hostingUserSummary.ChangeProjectandWorkspace'),
        'aria-labelledby': t(
          'reports.hostingUserSummary.ChangeProjectandWorkspace'
        ),
        'aria-describedby':
          t('reports.hostingUserSummary.SelectProjectandWorkspacetoview') +
          ` ${dialogReportName}`,
      }}
      maxWidth={false}
    >
      <ContentComponent
        heading={t('reports.hostingUserSummary.ChangeProjectandWorkspace')}
        subHeading={
          t('reports.hostingUserSummary.SelectProjectandWorkspacetoview') +
          ` ${dialogReportName}`
        }
        setParentCloseCB={(cb: () => void) => {
          closeCBFromChildRef.current = cb;
        }}
        openFrom={openFrom}
        hideNonConsilioProjects={hideNonConsilioProjects}
      />
    </Dialog>
  );
};

export default ProjectWorkSpaceSelectionDialog;
